export default {
    methods: {
        publicImage(name) {
            return `${process.env.VUE_APP_URL}/assets/${name}`;
        },
    }
}